import { compressUploadImage } from "./compressUploadImage";

/**
 * Downscale / re-encode product photos in the browser (WebP) before upload.
 * Large camera photos (multi‑MB) upload faster and avoid long hangs on slow links.
 * Same rules as compressUploadImage: GIF/SVG untouched, no WebP support -> the backend handles it.
 *
 * @param {File} file
 * @returns {Promise<File>}
 */
export async function compressProductImageFile(file) {
  // Product photos keep a generous size budget; the backend downsizes to its own limit anyway.
  return compressUploadImage(file, { maxEdge: 1920, quality: 0.82, maxBytes: 2 * 1024 * 1024 });
}
